import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import cc from 'classcat';
import { Button } from '../Button';

interface IMessageBox {
    title?: string;
    close: () => void;
    description: string;
    className?: string;
}

export const MessageBox = ({ title, close, description, className }: IMessageBox) => {
    const content = useSelector((state: RootState) => state.language.data);

    return (
        <div className={cc(['message-box', className])}>
            <h3 className="message-box__header">{title}</h3>
            <p className={cc(['paragraph-3', 'message-box__description', 'yes-no__description'])}>{description}</p>
            <div className="message-box__action">
                <Button onClick={close} text={content.common.cancel} variant="text" color="blue" />
            </div>
        </div>
    );
};
